import { ref } from 'vue';

export function useSorting (sortByDefault, sortAscDefault) {
    // Define reactive variables for sorting options
    const sortBy = ref(sortByDefault || '');
    const sortAsc = ref(sortAscDefault || true);

    /**
     * Sorts the provided array based on the current sortBy and sortAsc values.
     * @param {Array} array - The array to be sorted.
     * @param {string} field - The field in the object to sort by.
     * @returns {Array} - The sorted array.
     */
    const sortArray = (array, field = sortBy.value) => {
        if (!Array.isArray(array)) {
            console.error('The provided data is not an array');
            return array;
        }
        if (!array.length){
            return array
        }

        if (!array[0].hasOwnProperty(field)) {
            console.error(`Invalid field: ${field}`);
            return array;
        }

        const isDateField = (item) => {
            return !isNaN(Date.parse(item[field]));
        };

        return array.sort((a, b) => {
            let valueA = a[field];
            let valueB = b[field];

            if (isDateField(a)) {
                valueA = new Date(a[field]);
                valueB = new Date(b[field]);
            }

            if (sortAsc.value) {
                return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            } else {
                return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
            }
        });
    };

    return {
        sortBy,
        sortAsc,
        sortArray
    };
}

